import { useCallback } from 'react';
import { string } from 'yup';

type TextValidationProps = {
  maxCharacters: number;
  errorMessage?: string;
};

export const useTextLengthValidation = ({
  maxCharacters,
  errorMessage,
}: TextValidationProps) => {
  const defaultErrorMessage = `Can contain up to ${maxCharacters} characters`;

  const validateText = useCallback(
    async (value) => {
      try {
        await string()
          .required()
          .max(maxCharacters, errorMessage ?? defaultErrorMessage)
          .validate(value);
      } catch (e) {
        return e.message;
      }
    },
    [maxCharacters, errorMessage, defaultErrorMessage]
  );

  return {
    validateText,
  } as const;
};
